import PptxGenJS from "pptxgenjs"

import { ApiAccess } from 'features/session/types'

import { SearchDetailResult } from 'interface/search'
import { KojinResult } from 'interface/kojin'
import { GetAvatarImage } from 'interface/kojin/avatar'

import { KojinPptxComponentsProps, KojinPptxFormat, LayoutOption } from '../types'

import { header } from '../components/header'
import { organList } from '../components/organList'
import { attributes } from '../components/attributes'

import { CareNet, SystemName } from "constants/captions"

export const format: KojinPptxFormat = {
  reportId: 'nojournal',
  reportName: 'ヘッダーのみ',
  record: async (
    fileName: string,
    props: {
      apiAccess: ApiAccess
      search: SearchDetailResult
      kojinList: KojinResult[]
    },
    onProgress?: (percent: number) => void
  ) => {
    const { apiAccess, search, kojinList } = props

    const slideSize = {
      name: 'A4',
      width: 11.69,
      height: 8.27
    }
    const baseFont = {
      fontFace: '游ゴシック Medium',
      fontSize: 10.5
    }
    const textOption: PptxGenJS.TextPropsOptions = {
      ...baseFont,
      color: '000000'
    }
    const cellOption: PptxGenJS.TableCellProps = {
      ...textOption,
      margin: [0.05, 0.1, 0.05, 0.1]
    }
    const layout: LayoutOption = {
      baseFont: baseFont,
      textOption: textOption,
      cellOption: cellOption,
      slideSize: slideSize,
      margin: 0.2,
      footerHeight: 0.3,
      inchPerDot: 95
    }
    
    const pptx = new PptxGenJS()
    pptx.company = CareNet
    pptx.author = SystemName
    pptx.revision = '1'
    pptx.title = fileName
    pptx.subject = fileName
    pptx.defineLayout({
      name: slideSize.name,
      width: slideSize.width,
      height: slideSize.height,
    })
    pptx.layout = slideSize.name
    pptx.theme = {
      headFontFace: baseFont.fontFace,
      bodyFontFace: baseFont.fontFace
    }
    pptx.defineSlideMaster({
      title: "MASTER_SLIDE",
      background: { color: "FFFFFF" },
      objects: [{
        rect: {
          x: 0, y: slideSize.height - layout.footerHeight,
          w: slideSize.width, h: layout.footerHeight,
          fill: { color: "bcbdc0" }
        }
      }, {
        image: {
          x: 0, y: slideSize.height - layout.footerHeight,
          w: (layout.footerHeight * 663) / 90, h: layout.footerHeight,
          path: `${process.env.PUBLIC_URL}/slide_footer.png`
        }
      }],
      slideNumber: {
        ...textOption,
        x: slideSize.width - 0.5,
        y: slideSize.height - layout.footerHeight,
        w: 0.5, h: layout.footerHeight,
        fontSize: baseFont.fontSize * 0.8,
        align: 'center', valign: 'middle'
      },
      margin: [0, 0, layout.footerHeight, 0]
    })
    let n = 0
    for(const kojin of kojinList) {
      const componentProps: KojinPptxComponentsProps = {
        pptx, layout, 
        slide: pptx.addSlide({ masterName: 'MASTER_SLIDE' }),
        search
      }
      componentProps.avatarImage = await GetAvatarImage(
        apiAccess,
        kojin.kojinCode
      ).catch(() => undefined)

      let pos = 0
      pos = header({ ...componentProps, top: pos }).bottom
      pos = Math.max(
        organList({ ...componentProps, top: pos }).bottom,
        attributes({ ...componentProps, top: pos }).bottom
      )
      n++
      if (onProgress) onProgress((n * 100) / kojinList.length)
    }
    await pptx.writeFile({ fileName: `${fileName}.pptx` })
    return false
  }
}
